import gql from 'graphql-tag';

export const InstructionOverview = gql`
  query instruction($slug: String!, $topicSlug: String!, $guideSlug: String!, $locale: Locale!) {
    instruction(slug: $slug, topicSlug: $topicSlug, guideSlug: $guideSlug, locale: $locale) {
      id
      title
      imageUrl
      media {
        metadata
      }
      stepsNumber
      type
      requireSignature
      topicId
      steps {
        id
        position
        imageUrl
        instructionHtml
        tipHtml
        tipMedia {
          url
          metadata
        }
        fixHtml
        fixMedia {
          url
          metadata
        }
        warningHtml
        warningMedia {
          url
          metadata
        }
        alternativeHtml
        alternativeMedia {
          url
          metadata
        }
        media {
          metadata
        }
        notes {
          iconId
          contentHtml
          mandatory
          media {
            url
            metadata
          }
        }
      }
      nextInstruction {
        slug
        title
        imageUrl
        type
        media {
          metadata
        }
      }
      nextTopic {
        slug
        firstInstruction {
          type
          slug
          title
          imageUrl
          media {
            metadata
          }
        }
      }
      relatedInstructions {
        slug
        title
        imageUrl
        type
        media {
          metadata
        }
      }
    }
  }
`;
